import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.connected();
  }

  connected() {}

  disconnect() {
    this.disconnected();
  }

  disconnected() {}

  triggerElementEvent(name, detail = {}) {
    const event = new CustomEvent(name, { detail });
    this.element.dispatchEvent(event);
  }
}
